import { EmergencyConfigApi } from '../../generated-client/apis';
import type {
  EmergencyConfigurationOnAzure,
  AddEmergencyConfigRequest,
  UpdateEmergencyConfigRequest,
  DeleteEmergencyConfigRequest,
} from '../../generated-client/models';
import { useApiStore } from '../stores/apiStore';

let emergencyConfigApi: EmergencyConfigApi | null = null;
let lastConfig: unknown = null;

function getEmergencyConfigApi(): EmergencyConfigApi {
  const { apiConfig } = useApiStore.getState();
  if (emergencyConfigApi === null || lastConfig !== apiConfig) {
    emergencyConfigApi = new EmergencyConfigApi(apiConfig);
    lastConfig = apiConfig;
  }
  return emergencyConfigApi;
}

export const addEmergencyConfiguration = async (
  configuration: AddEmergencyConfigRequest,
): Promise<EmergencyConfigurationOnAzure> => {
  const api = getEmergencyConfigApi();
  return await api.apiEmergencyConfigAddEmergencyConfigPost({
    addEmergencyConfigRequest: configuration,
  });
};

export const deleteEmergencyConfiguration = async (
  request: DeleteEmergencyConfigRequest,
): Promise<void> => {
  const api = getEmergencyConfigApi();
  return await api.apiEmergencyConfigDeleteEmergencyConfigDelete({
    deleteEmergencyConfigRequest: request,
  });
};

export const updateEmergencyConfiguration = async (
  configuration: UpdateEmergencyConfigRequest,
): Promise<EmergencyConfigurationOnAzure> => {
  const api = getEmergencyConfigApi();
  return await api.apiEmergencyConfigUpdateEmergencyConfigPut({
    updateEmergencyConfigRequest: configuration,
  });
};

export const getAllEmergencyConfigurations = async (
  orgCode: string,
): Promise<Array<EmergencyConfigurationOnAzure>> => {
  const api = getEmergencyConfigApi();
  return await api.apiEmergencyConfigGetAllByOrgCodeGet({ orgCode });
};

export const getEmergencyConfigurationByOrgCodeAndId = async (
  orgCode: string,
  configId: string,
): Promise<EmergencyConfigurationOnAzure> => {
  const api = getEmergencyConfigApi();
  return await api.apiEmergencyConfigGetByOrgCodeAndIdGet({ orgCode, configId });
};
